module.exports = __webpack_public_path__ + "static/media/NoImage_F.e354b90b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/NoImage_F.jpg
// module id = 406
// module chunks = 20